"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.urlToUrlObject = void 0;
var querystring_1 = require("querystring");
var url_1 = require("url");
var urlToUrlObject = function (url) {
    var _a = typeof url === 'string' ? (0, url_1.parse)(url) : url instanceof URL ? (0, url_1.parse)(url.toString()) : url, pathname = _a.pathname, query = _a.query, hash = _a.hash;
    var parsedQuery = typeof query === 'string' ? (0, querystring_1.parse)(query) : query || {};
    return { pathname: pathname, query: parsedQuery, hash: hash };
};
exports.urlToUrlObject = urlToUrlObject;
//# sourceMappingURL=urlToUrlObject.js.map